var React = require('react');

function DropdownIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 1L8.68293 7L1 1","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"}));
}

DropdownIcon.defaultProps = {"width":"17","height":"9","viewBox":"0 0 17 9","fill":"none"};

module.exports = DropdownIcon;

DropdownIcon.default = DropdownIcon;
